import OrderApi from '@api/order'
import {
  ORDER_STATUS_PEND,
  ORDER_STATUS_COMPLETE
} from '@utils/constants'
import { isForeignCurrency, isOversea } from '@utils/assist'
import {
  ORDER_SET_PAID_LIST,
  ORDER_SET_UNPAID_LIST,
  ORDER_SET_ID,
  ORDER_SET_DETAIL,
  ORDER_SET_INVOICE,
  ORDER_SET_FULLNAME,
  ORDER_SET_INVOICE_STATUS,
  SIGN_PRE_PAYMENT_STATUS,
  SIGN_CONTRACT_STATUS,
  VERIFICATION_STATUS,
} from '../mutationTypes'

const isEmpty = data => data == null || Object.values(data).length < 1

const state = {
  paidList: [null],
  unpaidList: [null],
  orderId: '',
  detail: {},
  invoice: {},
  invoiceFlag: 0, // 订单详情页是否需要发票的标识
  signPrePaymentFlag: false,
  signContractFlag: false,
  verificationStatus: false,
  fullName: '',
}

const getters = {
  // 货币符号
  currency(state) {
    return state.detail.currency_label
  },
  // 是否时外币购买
  isForeignCurrency(state) {
    return isForeignCurrency(state.detail.currency_id)
  },
  // 是否是海外客户
  isOversea(state) {
    return isOversea(state.detail.is_oversea)
  },
  // 发票是否为空
  isInvoiceEmpty(state) {
    // 1，invoiceFlag > 0
    // 2，invoice不为空
    const isNeedInvoiceFlag = state.invoiceFlag > 0
    const isInvoiceEmpty = isEmpty(state.invoice)
    return isNeedInvoiceFlag && isInvoiceEmpty
  },
  // 发票是否必须
  isInvoiceMust(state) {
    return state.invoiceFlag > 0
  },
  // 公司名称——用于提交发票时发票抬头
  fullName (store) {
    return store.fullName
  },
  invoiceTime(state) {
    let time = state.invoice.invoiced_time
    if (!time) {
      return false
    }
    time = new Date(time.slice(0, 7)).getTime()
    const tplTime = new Date('2021-2').getTime()

    return time >= tplTime
  }
}

const actions = {
  async fetchOrderList({ commit }) {
    // 已支付订单列表
    const fetchPaidList = OrderApi.fetchOrderList({
      status: ORDER_STATUS_COMPLETE,
      page_size: 99999,
    })
    // 未支付订单列表
    const fetchUnPaidList = OrderApi.fetchOrderList({
      status: ORDER_STATUS_PEND,
      page_size: 99999,
    })

    const paidList = await fetchPaidList
    const unpaidList = await fetchUnPaidList
    commit(ORDER_SET_PAID_LIST, paidList.list)
    commit(ORDER_SET_UNPAID_LIST, unpaidList.list)
  },
  // 订单详情
  async fetchOrderDetail({ commit, state }) {
    const data = await OrderApi.fetchOrderDetail({
      order_id: state.orderId,
      token: window.__xm_wx.token,
    })
    commit(ORDER_SET_DETAIL, Object.freeze(data))
  },
  // 订单发票
  async fetchInvoice({ commit, state }) {
    const { invoice = {}, invoice_flag, full_name, sign_pre_payment_flag, sign_contract_flag, verification_status} = await OrderApi.fetchInvoice({
      order_id: state.orderId,
      token: window.__xm_wx.token,
    })
    commit(ORDER_SET_INVOICE, invoice)
    commit(ORDER_SET_FULLNAME, full_name)
    commit(ORDER_SET_INVOICE_STATUS, invoice_flag)
    commit(SIGN_PRE_PAYMENT_STATUS, sign_pre_payment_flag)
    commit(SIGN_CONTRACT_STATUS, sign_contract_flag)
    commit(VERIFICATION_STATUS, Boolean(verification_status))
  }
}

const mutations = {
  [ORDER_SET_PAID_LIST](state, data) {
    state.paidList = Object.freeze(data)
  },
  [ORDER_SET_UNPAID_LIST](state, data) {
    state.unpaidList = Object.freeze(data)
  },
  [ORDER_SET_ID](state, data) {
    state.orderId = data
  },
  [ORDER_SET_DETAIL](state, data) {
    state.detail = data
  },
  [ORDER_SET_INVOICE](state, data) {
    state.invoice = data || {}
  },
  [ORDER_SET_FULLNAME](state, data) {
    state.fullName = data
  },
  [ORDER_SET_INVOICE_STATUS](state, data) {
    state.invoiceFlag = data
  },
  [SIGN_PRE_PAYMENT_STATUS](state, data) {
    state.signPrePaymentFlag = data
  },
  [SIGN_CONTRACT_STATUS](state, data) {
    state.signContractFlag = data
  },
  [VERIFICATION_STATUS](state, data) {
    state.verificationStatus = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}